var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "bet-take",
      class: {
        "is-in-progress": _vm.isGameInProgress,
        "is-not-started": _vm.isGameNotStarted || _vm.isGameStartedWithoutSteps,
        "is-disabled": _vm.disabled,
      },
      on: { click: _vm.handleEndGame },
    },
    [
      _vm.isGameLost
        ? _c("div", { staticClass: "lost-container" }, [
            _c("span", { staticClass: "lost-text" }, [_vm._v("哎呀，小鸡")]),
            _c("span", { staticClass: "lost-text" }, [_vm._v("着火了 :(")]),
          ])
        : _vm.isGameInProgress
        ? [
            _c("span", { staticClass: "button-text" }, [
              _vm._v(_vm._s(_vm.buttonText)),
            ]),
            _c("div", { staticClass: "win-amount-group" }, [
              _c("i", { staticClass: "icon icon_coin-bold coin-icon" }),
              _c("span", { staticClass: "win-amount-text" }, [
                _vm._v(_vm._s(_vm.formattedPotentialWin)),
              ]),
            ]),
          ]
        : _vm.isGameStartedWithoutSteps
        ? void 0
        : _vm.isGameNotStarted
        ? [
            _vm.potentialWin > 0
              ? [
                  _c("div", { staticClass: "win-amount-group" }, [
                    _c("i", {
                      staticClass:
                        "icon icon_coin-bold coin-icon coin-icon--white",
                    }),
                    _c(
                      "span",
                      { staticClass: "win-amount-text win-amount-text--white" },
                      [_vm._v(" " + _vm._s(_vm.formattedPotentialWin) + " ")]
                    ),
                  ]),
                  _c(
                    "span",
                    { staticClass: "sub-label" },
                    [
                      !_vm.streamerMode
                        ? [_vm._v("可能的赢额")]
                        : [_vm._v("可能的距离")],
                    ],
                    2
                  ),
                ]
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }